
import styled from 'styled-components'

export const BlogLayout = styled.div`
  ${props => props.theme.css.container};
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  > div {
    &:first-child {
      flex: 1;
      min-width: 300px;
    }
  }
`
